import styled from "styled-components";
import Panel from "common/NewLook/Panel.tsx";

/**
 * New look: a flush panel around rows or a table. It clips its content so a
 * hovered or tinted last row keeps the panel's rounded corners.
 */
const TablePanel = styled(Panel)`
  overflow: hidden;
`;

export default TablePanel;
